import { Page, Tabs } from '@dixa/lib-shared-habla';
import { NotificationPayloadT, TemplateTypes } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import { useState } from 'react';

import { WithTemplatesInjectedProps } from 'hocs/templates/withTemplates';

import { TemplatesTab } from './components/templatesTab';

export type TemplatesDispatchProps = {
  notificationAdd: (payload: NotificationPayloadT) => void;
};

export type TemplatesStateProps = {
  hasLanguageTranslationControlFF: boolean;
};

type TemplatesProps = WithTemplatesInjectedProps &
  TemplatesDispatchProps &
  TemplatesStateProps;

enum TemplateTabs {
  QuickResponseTab = 'Quick response',
  AutoReplyTab = 'Auto reply',
}

const tabsDefinition = Object.values(TemplateTabs).map((tabName) => ({
  id: tabName,
  label: tabName,
}));

export const TEMPLATE_NAMES: Record<TemplateTypes, string> = {
  quick_response: 'Quick response',
  email_auto_reply: 'Auto reply',
  email_signature: 'Email signature',
};

export const Templates = (props: TemplatesProps): JSX.Element => {
  const [activeTab, setActiveTab] = useState(TemplateTabs.QuickResponseTab);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab as TemplateTabs);

    ampli.settingsTemplatesTabClicked({
      tab:
        Object.entries(TEMPLATE_NAMES).find(([_, name]) => name === tab)?.[0] ??
        '',
    });
  };

  const { templates, notificationAdd, hasLanguageTranslationControlFF } = props;

  return (
    <>
      <Page.Tabs>
        <Tabs
          selectedId={activeTab}
          tabs={tabsDefinition}
          onChange={handleTabChange}
        />
      </Page.Tabs>

      <Page.Body>
        {activeTab === TemplateTabs.QuickResponseTab && (
          <TemplatesTab
            templateType="quick_response"
            sectionTitle="All quick response templates"
            templates={templates}
            notificationAdd={notificationAdd}
            hasLanguageTranslationControlFF={hasLanguageTranslationControlFF}
          />
        )}

        {activeTab === TemplateTabs.AutoReplyTab && (
          <TemplatesTab
            templateType="email_auto_reply"
            sectionTitle="All auto reply templates"
            templates={templates}
            notificationAdd={notificationAdd}
            hasLanguageTranslationControlFF={hasLanguageTranslationControlFF}
          />
        )}
      </Page.Body>
    </>
  );
};
